import * as Backbone from 'backbone';
import * as _ from 'underscore';
import PageableCollection from 'backbone.paginator';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
});

export var Collection = PageableCollection.extend({
    mode: "client",
    model: Model,
    url: config.webApiUrl() + '/api/vendor/',
    // Initial pagination states
    state: {
        pageSize: 12,
        //sortKey: null,
        //directions: -1,
        //full: false
    },

    // You can remap the query parameters from `state` keys from
    // the default to those your server supports
    queryParams: {
        //totalPages: null,
        //totalRecords: null,
        //sortKey: "sort",
        //q: "state:closed repo:jashkenas/backbone"
        sortKey: 'id',
        //directions: 
        order: 1
    },

    options: {
        full: false
    },

    // get the state from Github's search API result
    /*parseState: function (resp, queryParams, state, options) {
        return { totalRecords: resp.total_count };
    },*/

    // get the actual records
    /*parseRecords: function (resp, options) {
        return resp.items;
    },*/
    "sync": function (method, model, options) {
        if (method == 'read') {
            if (options.id) {
                options.url = config.webApiUrl() + '/api/PublicSearchEvent/route04/' + options.id;
            }
            else if (options.first) {
                options.url = config.webApiUrl() + '/api/PublicSearchEvent/route01/-1?Country=' + options.country;
            }
            else {
                if (options.utcStartDate != null) {
                //if ((options.utcStartDate != null) && (options.utcEndDate != null)) {
                    options.url = config.webApiUrl() + '/api/PublicSearchEvent/route02/-1?' + 'Information=' + options.information + '&UtcStartDate=' + options.utcStartDate /*+ '&UtcEndDate=' + options.utcEndDate*/ + '&Latitude=' + options.latitude +
                    '&Longitude=' + options.longitude + '&Radius=' + options.radius + '&MaxRecord=' + options.maxRecord + '&Country=' + options.country + '&Bust=' + options.bust;
                }
                else {
                    options.url = config.webApiUrl() + '/api/PublicSearchEvent/route03/-1?' + 'Information=' + options.information + '&Latitude=' + options.latitude +
                    '&Longitude=' + options.longitude + '&Radius=' + options.radius + '&MaxRecord=' + options.maxRecord + '&Country=' + options.country + '&Bust=' + options.bust;
                }
            }
        }
        return Backbone.sync(method, model, options);
    }
    /*comparator: function (a, b) {
        return a.attributes.id < b.attributes.id ? -1
             : a.attributes.id > b.attributes.id ? 1
             : 0;
    }*/
});

